import React from "react";
import { cn } from "./cn";

/**
 * Bun toggle: 30x18 pill, blue when on, knob slides. Optional trailing label.
 */
const Toggle = React.forwardRef(function Toggle(
  { checked, onChange, label, disabled, className, ...inputProps },
  ref
) {
  return (
    <label
      className={cn(
        "inline-flex min-w-11 min-h-11 sm:min-w-0 sm:min-h-0 items-center gap-[9px] font-instrument text-bun-body font-book text-bun-text",
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
        className
      )}
    >
      <span className="relative inline-flex w-[30px] h-[18px] shrink-0">
        <input
          {...inputProps}
          ref={ref}
          type="checkbox"
          role="switch"
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="peer absolute inset-0 w-full h-full opacity-0 cursor-[inherit]"
        />
        <span
          aria-hidden="true"
          className={cn(
            "w-[30px] h-[18px] rounded-full transition-colors",
            checked ? "bg-bun-blue" : "bg-bun-track-off",
            "peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-bun-blue"
          )}
        >
          <span
            className={cn(
              "absolute top-[2px] w-[14px] h-[14px] rounded-full bg-bun-knob transition-all",
              checked ? "left-[14px]" : "left-[2px] shadow-bun-sm"
            )}
          />
        </span>
      </span>
      {label}
    </label>
  );
});

export default Toggle;
